// Тексти Mini App uk/ru/ro/en. Мова — з акаунта бота (POST /tg/auth → locale).
export type Locale = 'uk' | 'ru' | 'ro' | 'en';

const uk = {
  loading: 'Завантаження…',
  close: 'Закрити',
  error: 'Не вдалося. Спробуйте ще раз.',
  not_linked: 'Цей Telegram ще не привʼязано до VIA DOMUM. Попросіть код у диспетчера.',
  open_from_chat: 'Відкрийте цей екран з повідомлення в чаті бота.',
  // диспетчер
  handover_title: 'Передати партнеру',
  what: 'Що передаємо',
  scope_case: 'Всю справу',
  scope_transport: 'Тільки перевезення',
  scope_case_note: 'Партнер веде справу повністю: документи, родина, перевезення. Ми бачимо кроки.',
  scope_transport_note: 'Документи й родина лишаються на нас. Партнер тільки везе.',
  partner: 'Партнер',
  dpa_signed: 'угода про дані',
  dpa_missing: 'Угода про дані не підписана: тільки демо-справи',
  done_with_us: 'рейсів з нами',
  sees: 'Що бачить партнер',
  v_price: 'Ціна для родини',
  v_family_contacts: 'Контакти родини',
  v_all_documents: 'Документи справи',
  v_medical: 'Медичні дані',
  v_route: 'Маршрут',
  v_dates: 'Дати',
  partner_price: 'Ціна для партнера',
  price_note: 'Оплата після акту.',
  wait: 'Час на відповідь',
  min: 'хв',
  hour: 'год',
  wait_note: 'Не відповів чи відмовив: бот пише вам і пропонує наступного партнера або «Виконуємо самі».',
  send_to: 'Надіслати пропозицію',
  sent: 'Пропозицію надіслано. Відповідь прийде в чат.',
  offer_pending: 'Справу вже запропоновано партнеру — дочекайтеся відповіді.',
  // партнер
  offer: 'Пропозиція',
  route: 'Маршрут',
  pickup: 'Забрати',
  deliver_by: 'Доставити до',
  your_pay: 'Оплата вам',
  after_act: 'після акту',
  answer_in: 'Відповісти за',
  accept: 'Прийняти',
  decline: 'Відхилити',
  why: 'Причина відмови',
  why_no_vehicle: 'Немає авто',
  why_price: 'Ціна',
  why_no_route: 'Не їздимо туди',
  why_other: 'Інше',
  documents: 'Документи в дорогу',
  hidden: 'Приховано VIA DOMUM',
  driver: 'Водій',
  assign: 'Призначити',
  status_offered: 'Нова пропозиція',
  status_accepted: 'Прийнято',
  status_completed: 'Завершено',
  family_contacts: 'Контакти родини',
  // водій
  trip: 'Рейс',
  offline: 'Немає мережі',
  in_queue: 'у черзі',
  step_done: 'Крок виконано',
  add_photo: '+ фото',
  photo_needed: 'Додайте хоча б одне фото',
  problem: 'Проблема',
  p_delay: 'Затримка',
  p_documents: 'Документи',
  p_vehicle: 'Авто',
  p_other: 'Інше',
  problem_sent: 'Диспетчер уже бачить',
  receipt: 'Чек',
  e_fuel: 'Пальне',
  e_tolls: 'Дороги',
  e_border: 'Кордон',
  e_other: 'Інше',
  amount: 'Сума',
  save: 'Зберегти',
  saved: 'Збережено',
  no_trip: 'Активних рейсів немає.',
  all_done: 'Рейс завершено. Дякуємо!',
  s_departure: 'Виїзд',
  s_picked_up: 'Забрати з моргу',
  s_border_crossed: 'Кордон',
  s_delivered: 'Доставлено',
  // родина
  case: 'Справа',
  where_now: 'Де ми зараз',
  manager: 'Ваш менеджер',
  write_manager: 'Написати менеджеру',
  no_case: 'Відкритих справ поки немає.',
  f_accepted: 'Справу прийняли',
  f_docs_collecting: 'Збираємо документи',
  f_docs_ready: 'Документи готові',
  f_picked_up: 'Тіло забрали',
  f_in_transit: 'У дорозі',
  f_border_crossed: 'Кордон перетнуто',
  f_delivered: 'Доставлено',
  f_burial: 'Поховання',
};

export type Key = keyof typeof uk;

const ru: Partial<Record<Key, string>> = {
  loading: 'Загрузка…', close: 'Закрыть', error: 'Не удалось. Попробуйте ещё раз.',
  not_linked: 'Этот Telegram ещё не привязан к VIA DOMUM. Попросите код у диспетчера.',
  open_from_chat: 'Откройте этот экран из сообщения в чате бота.',
  handover_title: 'Передать партнёру', what: 'Что передаём', scope_case: 'Всё дело', scope_transport: 'Только перевозка',
  scope_case_note: 'Партнёр ведёт дело полностью: документы, семья, перевозка. Мы видим шаги.',
  scope_transport_note: 'Документы и семья остаются на нас. Партнёр только везёт.',
  partner: 'Партнёр', dpa_signed: 'соглашение о данных', dpa_missing: 'Соглашение о данных не подписано: только демо-дела',
  done_with_us: 'рейсов с нами', sees: 'Что видит партнёр', v_price: 'Цена для семьи', v_family_contacts: 'Контакты семьи',
  v_all_documents: 'Документы дела', v_medical: 'Медицинские данные', v_route: 'Маршрут', v_dates: 'Даты',
  partner_price: 'Цена для партнёра', price_note: 'Оплата после акта.', wait: 'Время на ответ', min: 'мин', hour: 'ч',
  wait_note: 'Не ответил или отказал: бот напишет вам и предложит следующего партнёра или «Выполняем сами».',
  send_to: 'Отправить предложение', sent: 'Предложение отправлено. Ответ придёт в чат.',
  offer_pending: 'Дело уже предложено партнёру — дождитесь ответа.',
  offer: 'Предложение', route: 'Маршрут', pickup: 'Забрать', deliver_by: 'Доставить до', your_pay: 'Оплата вам',
  after_act: 'после акта', answer_in: 'Ответить за', accept: 'Принять', decline: 'Отклонить', why: 'Причина отказа',
  why_no_vehicle: 'Нет авто', why_price: 'Цена', why_no_route: 'Не ездим туда', why_other: 'Другое',
  documents: 'Документы в дорогу', hidden: 'Скрыто VIA DOMUM', driver: 'Водитель', assign: 'Назначить',
  status_offered: 'Новое предложение', status_accepted: 'Принято', status_completed: 'Завершено', family_contacts: 'Контакты семьи',
  trip: 'Рейс', offline: 'Нет сети', in_queue: 'в очереди', step_done: 'Шаг выполнен', add_photo: '+ фото',
  photo_needed: 'Добавьте хотя бы одно фото', problem: 'Проблема', p_delay: 'Задержка', p_documents: 'Документы',
  p_vehicle: 'Авто', p_other: 'Другое', problem_sent: 'Диспетчер уже видит', receipt: 'Чек', e_fuel: 'Топливо',
  e_tolls: 'Дороги', e_border: 'Граница', e_other: 'Другое', amount: 'Сумма', save: 'Сохранить', saved: 'Сохранено',
  no_trip: 'Активных рейсов нет.', all_done: 'Рейс завершён. Спасибо!', s_departure: 'Выезд',
  s_picked_up: 'Забрать из морга', s_border_crossed: 'Граница', s_delivered: 'Доставлено',
  case: 'Дело', where_now: 'Где мы сейчас', manager: 'Ваш менеджер', write_manager: 'Написать менеджеру',
  no_case: 'Открытых дел пока нет.', f_accepted: 'Дело приняли', f_docs_collecting: 'Собираем документы',
  f_docs_ready: 'Документы готовы', f_picked_up: 'Тело забрали', f_in_transit: 'В пути', f_border_crossed: 'Граница пересечена',
  f_delivered: 'Доставлено', f_burial: 'Похороны',
};

const ro: Partial<Record<Key, string>> = {
  loading: 'Se încarcă…', close: 'Închide', error: 'Nu s-a reușit. Încercați din nou.',
  not_linked: 'Acest Telegram nu este încă legat de VIA DOMUM. Cereți un cod dispecerului.',
  open_from_chat: 'Deschideți acest ecran din mesajul din chatul botului.',
  handover_title: 'Transmite partenerului', what: 'Ce transmitem', scope_case: 'Tot dosarul', scope_transport: 'Doar transportul',
  scope_case_note: 'Partenerul duce tot dosarul: documente, familie, transport. Noi vedem pașii.',
  scope_transport_note: 'Documentele și familia rămân la noi. Partenerul doar transportă.',
  partner: 'Partener', dpa_signed: 'acord privind datele', dpa_missing: 'Acordul privind datele nu este semnat: doar dosare demo',
  done_with_us: 'curse cu noi', sees: 'Ce vede partenerul', v_price: 'Prețul pentru familie', v_family_contacts: 'Contactele familiei',
  v_all_documents: 'Documentele dosarului', v_medical: 'Date medicale', v_route: 'Traseu', v_dates: 'Date',
  partner_price: 'Prețul pentru partener', price_note: 'Plata după act.', wait: 'Timp de răspuns', min: 'min', hour: 'oră',
  wait_note: 'Nu a răspuns sau a refuzat: botul vă scrie și propune următorul partener sau „Executăm noi”.',
  send_to: 'Trimite oferta', sent: 'Oferta a fost trimisă. Răspunsul vine în chat.',
  offer_pending: 'Dosarul a fost deja propus unui partener — așteptați răspunsul.',
  offer: 'Ofertă', route: 'Traseu', pickup: 'Preluare', deliver_by: 'Livrare până la', your_pay: 'Plata dvs.',
  after_act: 'după act', answer_in: 'Răspundeți în', accept: 'Accept', decline: 'Refuz', why: 'Motivul refuzului',
  why_no_vehicle: 'Nu avem mașină', why_price: 'Prețul', why_no_route: 'Nu mergem acolo', why_other: 'Altceva',
  documents: 'Documente de drum', hidden: 'Ascuns de VIA DOMUM', driver: 'Șofer', assign: 'Desemnează',
  status_offered: 'Ofertă nouă', status_accepted: 'Acceptat', status_completed: 'Încheiat', family_contacts: 'Contactele familiei',
  trip: 'Cursă', offline: 'Fără rețea', in_queue: 'în coadă', step_done: 'Pas executat', add_photo: '+ foto',
  photo_needed: 'Adăugați cel puțin o fotografie', problem: 'Problemă', p_delay: 'Întârziere', p_documents: 'Documente',
  p_vehicle: 'Mașina', p_other: 'Altceva', problem_sent: 'Dispecerul vede deja', receipt: 'Bon', e_fuel: 'Combustibil',
  e_tolls: 'Taxe de drum', e_border: 'Frontieră', e_other: 'Altele', amount: 'Suma', save: 'Salvează', saved: 'Salvat',
  no_trip: 'Nu sunt curse active.', all_done: 'Cursa s-a încheiat. Mulțumim!', s_departure: 'Plecare',
  s_picked_up: 'Preluare de la morgă', s_border_crossed: 'Frontiera', s_delivered: 'Livrat',
  case: 'Dosarul', where_now: 'Unde suntem acum', manager: 'Managerul dvs.', write_manager: 'Scrieți managerului',
  no_case: 'Încă nu aveți dosare deschise.', f_accepted: 'Am preluat dosarul', f_docs_collecting: 'Colectăm documentele',
  f_docs_ready: 'Documentele sunt gata', f_picked_up: 'Corpul a fost preluat', f_in_transit: 'Pe drum',
  f_border_crossed: 'Frontiera a fost trecută', f_delivered: 'Livrat', f_burial: 'Înmormântarea',
};

const en: Partial<Record<Key, string>> = {
  loading: 'Loading…', close: 'Close', error: 'Something went wrong. Please try again.',
  not_linked: 'This Telegram is not linked to VIA DOMUM yet. Ask the dispatcher for a code.',
  open_from_chat: 'Open this screen from a message in the bot chat.',
  handover_title: 'Hand over to a partner', what: 'What we hand over', scope_case: 'Whole case', scope_transport: 'Transport only',
  scope_case_note: 'The partner runs the whole case: documents, family, transport. We see the steps.',
  scope_transport_note: 'Documents and the family stay with us. The partner only drives.',
  partner: 'Partner', dpa_signed: 'data agreement', dpa_missing: 'No signed data agreement: demo cases only',
  done_with_us: 'trips with us', sees: 'What the partner sees', v_price: 'Family price', v_family_contacts: 'Family contacts',
  v_all_documents: 'Case documents', v_medical: 'Medical data', v_route: 'Route', v_dates: 'Dates',
  partner_price: 'Partner price', price_note: 'Paid after the act.', wait: 'Reply time', min: 'min', hour: 'h',
  wait_note: 'No reply or declined: the bot messages you and suggests the next partner or "We do it ourselves".',
  send_to: 'Send the offer', sent: 'The offer was sent. The reply will come to the chat.',
  offer_pending: 'The case is already offered to a partner — wait for the reply.',
  offer: 'Offer', route: 'Route', pickup: 'Pick up', deliver_by: 'Deliver by', your_pay: 'Your payment', after_act: 'after the act',
  answer_in: 'Reply within', accept: 'Accept', decline: 'Decline', why: 'Reason', why_no_vehicle: 'No vehicle',
  why_price: 'Price', why_no_route: "We don't go there", why_other: 'Other', documents: 'Travel documents',
  hidden: 'Hidden by VIA DOMUM', driver: 'Driver', assign: 'Assign', status_offered: 'New offer', status_accepted: 'Accepted',
  status_completed: 'Completed', family_contacts: 'Family contacts',
  trip: 'Trip', offline: 'No network', in_queue: 'queued', step_done: 'Step done', add_photo: '+ photo',
  photo_needed: 'Add at least one photo', problem: 'Problem', p_delay: 'Delay', p_documents: 'Documents', p_vehicle: 'Vehicle',
  p_other: 'Other', problem_sent: 'The dispatcher already sees it', receipt: 'Receipt', e_fuel: 'Fuel', e_tolls: 'Tolls',
  e_border: 'Border', e_other: 'Other', amount: 'Amount', save: 'Save', saved: 'Saved', no_trip: 'No active trips.',
  all_done: 'The trip is complete. Thank you!', s_departure: 'Departure', s_picked_up: 'Pick up from the morgue',
  s_border_crossed: 'Border', s_delivered: 'Delivered',
  case: 'Case', where_now: 'Where we are now', manager: 'Your manager', write_manager: 'Message the manager',
  no_case: 'No open cases yet.', f_accepted: 'Case accepted', f_docs_collecting: 'Collecting documents',
  f_docs_ready: 'Documents are ready', f_picked_up: 'The body has been collected', f_in_transit: 'On the way',
  f_border_crossed: 'Border crossed', f_delivered: 'Delivered', f_burial: 'Burial',
};

const ALL: Record<Locale, Partial<Record<Key, string>>> = { uk, ru, ro, en };
let current: Locale = 'uk';

export function setLocale(l: string | null | undefined): Locale {
  const b = (l ?? '').toLowerCase().split('-')[0];
  current = (['uk', 'ru', 'ro', 'en'] as const).includes(b as Locale) ? (b as Locale) : 'uk';
  document.documentElement.lang = current;
  return current;
}

export function t(key: Key): string {
  return ALL[current][key] ?? uk[key];
}

export function missingKeys(): Record<Locale, Key[]> {
  const keys = Object.keys(uk) as Key[];
  return { uk: [], ru: keys.filter((k) => !ru[k]), ro: keys.filter((k) => !ro[k]), en: keys.filter((k) => !en[k]) };
}
